import { getAuthTokenClient } from '@/utils/helpers';
import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';
import {
  TypeUserPreferenceName,
  TypeUserPreferenceRecord,
} from '@/lib/api/accountManager/types';

export type CreateUserPreferencesParams = {
  userUuid: string;
  preferenceName: TypeUserPreferenceName;
  preferenceValue: boolean;
  authToken?: string;
};

export async function createUserPreferences(
  params: CreateUserPreferencesParams,
) {
  const { userUuid, preferenceName, preferenceValue, authToken } = params;

  if (!userUuid || !preferenceName || !preferenceValue) {
    console.warn('[createUserPreferences]: Missing Required Params');
  }

  const body = {
    preference_name: preferenceName,
    preference_value: preferenceValue,
  };

  const config = {
    method: 'POST',
    headers: {
      Authorization: authToken ? authToken : await getAuthTokenClient(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  const response = await fetch(
    `${API_URLS.ACCOUNT_MANAGER}users/${userUuid}/user_preferences`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<TypeUserPreferenceRecord>;
}
